import styled from '@emotion/styled';
import { BREAKPOINTS, mediaQuery } from '@presentation/styles';
import { Button } from '../Button';

export const BellIcon = styled.div<{ hasUnread: boolean }>`
  position: relative;
  font-size: 24px;
  line-height: 24px;
  height: 24px;
  cursor: pointer;
  color: ${(props) => props.theme.color.blue.default};
  :hover {
    color: ${(props) => props.theme.color.blue.tint};
  }

  ${(props) =>
    props.hasUnread &&
    `
    &:after {
      content: "";
      position: absolute;
      top: 4px;
      right: 2px;
      width: 8px;
      height: 8px;
      border-radius: 100%;
      background-color: ${props.theme.color.red.default};
    }
  `};
`;

export const Container = styled.div`
  position: fixed;
  width: 430px;
  top: 80px;
  right: 24px;
  filter: drop-shadow(-1px 3px 16px rgba(149, 157, 165, 0.19));
  background: white;
  border-radius: 8px;

  ${mediaQuery(BREAKPOINTS.small)} {
    width: 100%;
    right: 0px;
    top: 74px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  gap: 8px;
  border-bottom: 1px solid ${(props) => props.theme.color.light.shade};
`;

export const Title = styled.div`
  width: 100%;
  font-weight: 600;
  font-size: 18px;
  color: ${(props) => props.theme.color.dark.default};
`;

export const RightAlignedButton = styled(Button)<{ hasUnread: boolean }>`
  padding: 0;
  justify-content: end;
  color: ${(props) => (props.hasUnread ? props.theme.color.light : props.theme.color.dark)}
  :hover{
    text-decoration : ${(props) => (props.hasUnread ? 'underline' : 'none')};
    font-weight: ${(props) => (props.hasUnread ? '900' : '700')};normal
  }
`;

export const List = styled.ul`
  margin: 0;
  max-height: 250px;
  overflow-y: auto;
  > li:not(:last-child) {
    border-bottom: 1px solid ${(props) => props.theme.color.light.shade};
  }
`;

export const Item = styled.li<{ read?: string }>`
  position: relative;
  padding: 16px 46px 16px 16px;
  font-size: 14px;
  color: ${(props) =>
    props.read === 'false' ? props.theme.color.blue.default : props.theme.color.dark.default};
  font-weight: ${(props) => (props.read === 'false' ? 'bold' : 'normal')};
  cursor: pointer;

  &:hover {
    background-color: ${(props) => props.theme.color.light.tint};
  }

  p {
    color: ${(props) => props.theme.color.dark.default};
    margin: 0;
  }

  small {
    display: block;
    font-size: 13px;
    color: ${(props) => props.theme.color.medium.default};
    margin-top: 8px;
  }

  ${(props) =>
    props.read === 'false' &&
    `
    &:after {
      content: '';
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 24px;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background-color: ${props.theme.color.blue.default};
    }}
    `}
`;
